export const CRDS_RESPONDENT_WITH_ACTE_REMUNERATION_PREFIX = '273';
export const CRDS_RESPONDENT_WITH_MIXTE_REMUNERATION_PREFIX = '274';

export const CRDS_RESPONDENT_LUMPSUM_CODES = ['xxx293', 'xxx294', 'xxx295', 'xxx296'];

export const isCrdsRespondentCode = (code) => CRDS_RESPONDENT_LUMPSUM_CODES.includes(code);
